
import Component from 'vue-class-component';
import moduleStore from '../../store';
import Vue from 'vue';
import PageState from '../../store/state';
import { customCollectEvent } from '@/utils/collect';

/**components**/
@Component({})
@moduleStore.initVuex({
	mutationNames: moduleStore.mutationNames,
	actionNames: moduleStore.actionNames
})
export default class buyVoicePopupComponent extends Vue {
    state: any = null;
    
    created(moduleData: IinjectDatas) {
		this.state = <PageState>moduleData.state;
	}

	hideSpeakerBuyWindow(){
		this.state.buyVoicePopupVisible = false
		this.state.selectPaySpeaker = null
	}

	gotoVoiceShop() {
		let href=location.href
		if(href.indexOf('source=app')!=-1){
      let openVoiceShopPage:any=(<any>window).openVoiceShopPage
      let param:string=JSON.stringify({speaker:this.state.selectPaySpeaker.speaker,speakerName:this.state.selectPaySpeaker.name})
      openVoiceShopPage.postMessage(param)
    }else{
			this.$navigateTo({
				url: `/pages/voice-shop/voice-shop?speaker=${this.state.selectPaySpeaker.speaker}&speakerName=${this.state.selectPaySpeaker.name}&pageType=back&ww_token=${this.state.ww_token}`
			})
		}

    customCollectEvent('editor_voice_buy', {
      'button': '查看声音'
    })
	}
	closeVoicePopupMsg(){
		this.state.selectPaySpeaker = null;
		this.$emit('change-play-status')
	}
}